import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import TranscribedAudio from "models/audioEditor/TranscribedAudio";
import RSVP from "rsvp";

const SequencerLibrary =  Backbone.Model.extend({
    idAttribute: "id",

    constructor: function(attributes, options) {

        // Compound-keyed cache: transcriptionId|languageCode|audioUrl → TranscribedAudio.
        // Keyed by transcript identity (not just URL) so that reloading the same
        // media with a different transcription, language, or speaker configuration
        // does not silently reuse stale parsed-word state.
        this._transcriptKeyToTranscriptionAudioMap = {};
        // Reverse index: audioUrl → most-recently-loaded TranscribedAudio for that URL.
        // Used by getExistingAudioSegmentFromJSON where serialized AudioSegments only
        // carry the audioUrl and need to locate their originating TranscribedAudio.
        this._audioUrlToTranscriptionAudioMap = {};

        Backbone.Model.apply(this, [attributes, options]);
    },

    _buildTranscriptCacheKey : function(audioUrl, transcriptionId, languageCode){
        // Include transcriptionId + languageCode so the same media loaded with a
        // different transcript / language produces a distinct cache entry.
        // Fall back to the URL alone for callers that predate transcriptionId.
        const transcriptionIdPart = transcriptionId || "";
        const languageCodePart = languageCode || "";
        return transcriptionIdPart + "|" + languageCodePart + "|" + audioUrl;
    },

    getTranscribeAudio : function(audioUrl, transcriptionJsonURL, audioBufferDurationInMilliseconds, transcriptionId, isVideo, speakerInfoSerializedDataArray, additionalSpeakerInfoArray, generateSpeakerLabelIfDuplicate, languageCode, videoWidth, videoHeight){
        const cacheKey = this._buildTranscriptCacheKey(audioUrl, transcriptionId, languageCode);
        if(!this._transcriptKeyToTranscriptionAudioMap[cacheKey]){
            const transcribedAudio = new TranscribedAudio({"audioUrl": audioUrl, "transcriptJsonURL":transcriptionJsonURL, "audioBufferDurationInMilliseconds": audioBufferDurationInMilliseconds, "transcriptionId": transcriptionId, "hasVideo": isVideo,"speakerInfoSerializedDataArray":speakerInfoSerializedDataArray,generateSpeakerLabelIfDuplicate, languageCode, "videoWidth":videoWidth, "videoHeight": videoHeight });
            this._transcriptKeyToTranscriptionAudioMap[cacheKey] = transcribedAudio;
            this._audioUrlToTranscriptionAudioMap[audioUrl] = transcribedAudio;
            return transcribedAudio.loadAndProcessTranscription(additionalSpeakerInfoArray).then((function(){
                return this._transcriptKeyToTranscriptionAudioMap[cacheKey];
            }).bind(this));
        }
        // Refresh the URL reverse index to point at the cache hit so segment
        // lookups by URL stay consistent with the last-loaded transcript.
        this._audioUrlToTranscriptionAudioMap[audioUrl] = this._transcriptKeyToTranscriptionAudioMap[cacheKey];
        return RSVP.Promise.resolve(this._transcriptKeyToTranscriptionAudioMap[cacheKey]);
    },

    clearCachedTranscribeAudio : function(audioUrl){
        // Remove every compound-key entry that maps to this audioUrl. A single
        // URL can have multiple entries (different languages/transcriptions).
        const keysToDelete = [];
        for(const key in this._transcriptKeyToTranscriptionAudioMap){
            if(Object.prototype.hasOwnProperty.call(this._transcriptKeyToTranscriptionAudioMap, key)){
                const entry = this._transcriptKeyToTranscriptionAudioMap[key];
                if(entry && entry.get && entry.get("audioUrl") === audioUrl){
                    keysToDelete.push(key);
                }
            }
        }
        for(let i =0; i < keysToDelete.length; i++){
            delete this._transcriptKeyToTranscriptionAudioMap[keysToDelete[i]];
        }
        delete this._audioUrlToTranscriptionAudioMap[audioUrl];
    },

    clearAllCachedTranscribeAudio : function(){
        this._transcriptKeyToTranscriptionAudioMap = {};
        this._audioUrlToTranscriptionAudioMap = {};
    },

    getExistingAudioSegmentFromJSON : function(audioSegmentJSON){
        if(!audioSegmentJSON){
            return;
        }
        const serializedTranscribedAudio = audioSegmentJSON.transcribedAudioInstance;
        if(serializedTranscribedAudio){
            const exactCacheKey = this._buildTranscriptCacheKey(
                serializedTranscribedAudio.audioUrl || audioSegmentJSON.audioUrl,
                serializedTranscribedAudio.transcriptionId,
                serializedTranscribedAudio.languageCode
            );
            const exactTranscribedAudio = this._transcriptKeyToTranscriptionAudioMap[exactCacheKey];
            if(exactTranscribedAudio){
                return exactTranscribedAudio.getAudioSegmentMatchingStartAndEndTime(audioSegmentJSON);
            }
        }
        if(this._audioUrlToTranscriptionAudioMap[audioSegmentJSON.audioUrl]){
            return this._audioUrlToTranscriptionAudioMap[audioSegmentJSON.audioUrl].getAudioSegmentMatchingStartAndEndTime(audioSegmentJSON)
        }
    },



});



const SequencerLibraryInstance = new SequencerLibrary();
window.trebble.globalHelpers.SequencerLibrary = SequencerLibraryInstance;

export default {
    getInstance : function() {
        return SequencerLibraryInstance;
    }
}; 
